import React, { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "moment/locale/pt-br";
import "react-toastify/dist/ReactToastify.css";
import { initI18n } from "../shared/i18n";
import theme from "../styles";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory,
} from "react-router-dom";

import {
  App,
  Authentication,
  AuthenticationContext,
  Distribution,
} from "../modules";
import "./global.css";
import { MuiThemeProvider } from "@material-ui/core";

initI18n();

const RootPath = () => {
  const history = useHistory();

  useEffect(() => {
    history.push("/app");
  }, []);

  return <App />;
};

const Main = () => {
  return (
    <AuthenticationContext>
      <MuiThemeProvider theme={theme}>
        <ToastContainer />

        <Router>
          <Switch>
            <Route exact path="/" component={RootPath} />
            <Route path="/app" component={App} />
            <Route path="/authentication" component={Authentication} />
            <Route path="/:path/" component={Distribution} />
          </Switch>
        </Router>
      </MuiThemeProvider>
    </AuthenticationContext>
  );
};

export default Main;
